import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Link, Navbar, NavLeft, NavTitle, Page } from 'framework7-react';
import ThankyouContent from './common/ThankyouContent';
import II18 from './translate/II18';
import { f7navigator } from './helpers/navigator';

class ThankyouMobile extends React.Component {
  render = () => {
    return (
      <Page name="home" style={{ background: 'white' }}>
        <Navbar>
          <NavLeft>
            <Link
              id={'navigateBack'}
              onClick={() => f7navigator.forceBackToList()}
            >
              <Icon ios="f7:chevron_left" md="material:arrow_back" />{' '}
              {this.$f7.device.ios ? II18.get('title_back') : ''}
            </Link>
          </NavLeft>
          <NavTitle>
            <label>{II18.get('title_successfull')}</label>
          </NavTitle>
        </Navbar>
        <ThankyouContent
          recipientRequestId={this.props.recipientRequestId}
          companyName={this.props.companyName}
        />
      </Page>
    );
  };
}

ThankyouMobile.propTypes = {
  recipientRequestId: PropTypes.string,
  caseName: PropTypes.string,
  companyName: PropTypes.string
};

export default ThankyouMobile;
